/**
 * PWA Handler - Managed Service Worker registration and Installation Prompt
 * Last Updated: 2026-04-06
 */

/**
 * PWA Handler - Managed Service Worker registration and Installation Prompt
 * Last Updated: 2026-04-08
 */

export function initPWA() {
    console.log('[PWA] Initializing PWA Handler...');

    // 1. Installation Prompt Logic
    let deferredPrompt: any = null;

    window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault();
        deferredPrompt = e;
        console.log('[PWA] beforeinstallprompt event fired');
        
        const installBtn = document.getElementById('pwaInstallBtn');
        if (installBtn) {
            installBtn.style.display = 'block';
        }
    });

    window.addEventListener('appinstalled', () => {
        console.log('[PWA] App was installed.');
        const installBtn = document.getElementById('pwaInstallBtn');
        if (installBtn) {
            installBtn.style.display = 'none';
        }
    });

    (window as any).triggerPWAInstall = async () => {
        if (!deferredPrompt) {
            console.log('[PWA] No deferred prompt available.');
            return;
        }
        deferredPrompt.prompt();
        const { outcome } = await deferredPrompt.userChoice;
        console.log(`[PWA] User response to the install prompt: ${outcome}`);
        deferredPrompt = null;
        
        const installBtn = document.getElementById('pwaInstallBtn');
        if (installBtn) {
            installBtn.style.display = 'none';
        }
    };

    // 2. Service Worker Update Logic
    // Using simple version check via reload for now, as virtual:pwa-register
    // requires specific build-time setup.
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.addEventListener('controllerchange', () => {
            console.log('[PWA] Controller changed. New version observed.');
            // Optional: Force reload if the version changed while the app was open
            // window.location.reload(); 
        });
    }
}
